// Sort a copy so report filters never change the source brand list.
export const sortReportBrands = (brands = []) => [...brands].sort((first, second) =>
  first.name.toLowerCase().localeCompare(second.name.toLowerCase())
);
